import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "translate",
  "use": "translate-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"translate\"><path d=\"M31 13H19V1a1 1 0 00-1-1H1a1 1 0 00-1 1v17a1 1 0 001 1h12v12a1 1 0 001 1h17a1 1 0 001-1V14a1 1 0 00-1-1zm-18 1v3H2V2h15v11h-3a1 1 0 00-1 1zm17 16H15V15h15z\" /><path d=\"M9 6V4H7v2H5v2h2v1.42A3.57 3.57 0 004 13a3.16 3.16 0 003 3c1.74 0 2-2.51 2-4v-.73a3.2 3.2 0 012 .73c0 .94-2 1-2 1v2c1.38 0 4-.63 4-3 0-1.59-2-2.59-4-2.73V8h5V6zm-2 6a7.07 7.07 0 01-.26 2A1.21 1.21 0 016 13a1.47 1.47 0 011-1.48zM21.09 25h2.82l.84 3H27l-3.37-11h-2.25L18 28h2.25zm1.41-5l.84 3h-1.68z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/translate.svg
// module id = bCxx
// module chunks = 39 44